import {
  ApiService,
} from '@/internal';

export default class BugReportService extends ApiService {

  store(payload = {}) {

    const {params, ...rest} = payload;

    return this.request({
      method: 'post',
      url: '/bug-reports',
      params: this.prepareParams(params),
      data: this.preparePayload(rest),
    });
  }
}
